import { render, staticRenderFns } from "./shakeGame.vue?vue&type=template&id=8db75de4&scoped=true"
import script from "./shakeGame.vue?vue&type=script&lang=js"
export * from "./shakeGame.vue?vue&type=script&lang=js"
import style0 from "./shakeGame.vue?vue&type=style&index=0&id=8db75de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db75de4",
  null
  
)

export default component.exports